export default __webpack_public_path__ + "3bff7e8c2e7ea2837afed43e80cc8cb4.woff";